/** Parse numeric id from public SEO slugs like `ballet-beginners-123`. */
export function parsePublicSlugId(slug: string): number | null {
  const segment = slug.split("-").pop();
  if (!segment) return null;

  const id = Number(segment);
  if (!Number.isInteger(id) || id <= 0) return null;

  return id;
}
